import { useEffect, useState } from "react"

import { getListOptions } from "../../Settings/components/settings-lists/list-options.services.ts"
import type { ManagedListKey } from "../../Settings/components/settings-lists/list-options.types.ts"

export interface ManagedListOptionItem {
  label: string
  value: string
}

/** A managed list's active options, shared by every picker so they never drift. */
export function useManagedListOptions(listKey: ManagedListKey, enabled = true) {
  const [options, setOptions] = useState<ManagedListOptionItem[]>([])
  const [loadFailed, setLoadFailed] = useState(false)

  useEffect(() => {
    if (!enabled) return
    let cancelled = false
    void getListOptions(listKey).then((response) => {
      if (cancelled) return
      if (!response.ok || !response.data) {
        setLoadFailed(true)
        return
      }
      setLoadFailed(false)
      setOptions(
        response.data.results
          .filter((option) => option.is_active)
          .map((option) => ({ label: option.label, value: option.value }))
      )
    })
    return () => {
      cancelled = true
    }
  }, [listKey, enabled])

  return { options, loadFailed }
}
